import React from 'react';
import { Button } from 'react-bootstrap';
import NoFeedbackOptionComponent from '../../../components/troubleShooting/articleDetails/NoFeedbackOptionComponent';
import ReactGA from 'react-ga4';

const FeedbackComponent = (props) => {
    const { ua, userAgent } = props.detectedDevice;
    let pageData = (props.pageData.data) ? props.pageData.data : null;
    let isAndroidOrIphone = ua && ua.toString().toLowerCase().replace(/\s/g, "").indexOf('iphone') > -1 ? true 
                            : userAgent && userAgent.toString().toLowerCase().replace(/\s/g, "").indexOf('iphone') > -1 ? true 
                            : ua && ua.toString().toLowerCase().replace(/\s/g, "").indexOf('android') > -1 ? true 
                            : userAgent && userAgent.toString().toLowerCase().replace(/\s/g, "").indexOf('android') > -1 ? true : false;

    return (
        <div>
            {pageData ?
                <div className="feedback">
                    <div className="card contact-card">

                        <div className="card-body text-left">
                            <h5 className="card-title">{pageData.FBQuestionLabel}</h5>

                            <Button type="button" disabled={props.btnDisable} onClick={props.fbHandler} data-value={1} className={(parseInt(props.isSelected) === 1 && parseInt(props.isHelpFul) === 1) ? `btn btn-lg col-5 col-md-5 col-sm-5 card-link yes-btn btn-danger ` : `btn btn-lg btn-light col-4 col-md-5 col-sm-5 card-link yes-btn`} >{pageData.YesButton}</Button>

                            <Button type="button" disabled={props.btnDisable} onClick={props.openModal} data-value={0} className={(parseInt(props.isSelected) === 1 && parseInt(props.isHelpFul) === 0) ? `btn btn-lg btn-danger col-5 col-md-5 col-sm-5 card-link no-btn ` : `btn btn-lg btn-light col-4 col-md-5 col-sm-5 card-link no-btn`}>{pageData.NoButton}</Button>

                            {parseInt(props.isSelected) === 1 && parseInt(props.isHelpFul) === 0 ?

                                <div>
                                    <p className="card-text mt-5"> {pageData.PropDiffChannelSentence}</p>
                                    <div className="row mx-0 card-main-div" >

                                        <div className="contact-card-list col-12 col-sm-10 col-md-4 col-xl-4  " onClick={() => {
                                            ReactGA.event('Click', {
                                                category: 'DoAfterNo',
                                                action: 'Click',
                                                event_category: 'DoAfterNo',
                                                event_action: 'Click',
                                                event_label: 'Lineで問い合わせる',
                                                UserID: (props.userID) ? props.userID : 'noAuth'
                                            });
                                        }}>
                                            <a href={pageData.line.url}>
                                                <div className="media contact-media">
                                                    <div className="media-left">

                                                        <img className="media-object contact-icon contact_LINE_icon" src="/images/image_contact_LINE.png" alt="Contact LINE" />

                                                    </div>
                                                    <div className="media-body">
                                                        <p>
                                                            <span className="line-title"> {pageData.line.BtnLbl} </span>
                                                            <span className="line-sub-title"> {pageData.line.Timelbl} </span>
                                                        </p>

                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        {!isAndroidOrIphone ? <div className="contact-card-list col-12 col-sm-10 col-md-4 col-xl-4 noIpadClick">
                                            {/* <a href={"tel:" + pageData.call.number} className="noClick "> */}
                                            <div className="media contact-media ">
                                                <div className="media-left">

                                                    <img className="media-object contact-icon image_contact_phone" src="/images/image_contact_phone.png" alt="Contact Phone" />

                                                </div>
                                                <div className="media-body">
                                                    <p>
                                                        <span x-ms-format-detection="none" className="line-title"> {pageData.call.number}</span>
                                                        <span className="line-sub-title"> {pageData.call.Timelbl} </span>
                                                    </p>
                                                </div>
                                            </div>
                                            {/* </a> */}
                                        </div> : <div className="contact-card-list col-12 col-sm-10 col-md-4 col-xl-4 noClick " onClick={() => {
                                            ReactGA.event('Click', {
                                                category: 'DoAfterNo',
                                                action: 'Click',
                                                event_category: 'DoAfterNo',
                                                event_action: 'Click',
                                                event_label: '電話',
                                                UserID: (props.userID) ? props.userID : 'noAuth'
                                            });
                                        }}>

                                                <a href={"tel:" + pageData.call.number} className="noClick ">
                                                    <div className="media contact-media ">
                                                        <div className="media-left">

                                                            <img className="media-object contact-icon image_contact_phone" src="/images/image_contact_phone.png" alt="Contact Phone" />

                                                        </div>
                                                        <div className="media-body">
                                                            <p>
                                                                <span className="line-title"> {pageData.call.number}</span>
                                                                <span className="line-sub-title"> {pageData.call.Timelbl} </span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>}
                                        <div className="contact-card-list col-12 col-sm-10 col-md-4 col-xl-4  " onClick={() => {
                                            ReactGA.event('Click', {
                                                category: 'DoAfterNo',
                                                action: 'Click',
                                                event_category: 'DoAfterNo',
                                                event_action: 'Click',
                                                event_label: 'お問い合わせフォーム',
                                                UserID: (props.userID) ? props.userID : 'noAuth'
                                            });
                                        }}>
                                            <a href={pageData.enquiry.url}>
                                                <div className="media contact-media">
                                                    <div className="media-left">

                                                        <img className="media-object contact-icon contact_envelope" src="/images/image_contact_envelope.png" alt="Contact Envelope" />

                                                    </div>
                                                    <div className="media-body">

                                                        <span className="line-title contact_envelope_title">{pageData.enquiry.label}</span>



                                                    </div>
                                                </div>
                                            </a>
                                        </div>

                                    </div> </div> : ''}

                            {parseInt(props.isHelpFul) === 1 && parseInt(props.isSelected) === 1 ? <p className="card-text mt-4 mb-2"> {pageData.ThankYouMessage}</p> : ''}
                        </div>
                    </div>
                    <div className="row topLink">
                        {/*  <button onClick={props.clickHandler} className="btn btn-default" >{pageData.ReturnToPage} ></button> */}
                        <a href={pageData.DocomoTopPage} alt={pageData.ReturnToPage} className="btn btn-default"> {pageData.ReturnToPage} {'>'} </a>
                    </div>
                </div> : ''}
                <NoFeedbackOptionComponent haschildren={props.haschildren} getchildren={props.getchildren} NofeedbackOptionsData={props.NofeedbackOptionsData} noFeedbackOptionSelected={props.noFeedbackOptionSelected} isOpen={props.isOpen} saveNoFeedback={props.saveNoFeedback} handleInputChange={props.handleInputChange}/>
                

        </div>

        
    );
};
export default FeedbackComponent;